import initAddressConfirmation from "components/jiffy/contactus-address-confirmation/contactus-address-confirmation";
import initLateOrder from "components/jiffy/contactus-late-order/contactus-late-order";
import initClaimImageUploader from "components/jiffy/claim-image-uploader/claim-image-uploader";
import initCustomReasonField from "components/jiffy/claim-form/claim-form";
import "components/jiffy/contact-us-template/contact-us-template";
import CustomerRequestFormTracker from "common/utils/customer-request-tracker";
import "components/jiffy/contact-us/contact-us";
import "components/jiffy/return-items/return-items";
import "components/jiffy/artwork-service-name/artwork-service-name";
import "components/jiffy/return-request/return-request-first-request-confirmation-modal/return-request-first-request-confirmation-modal";
import "components/jiffy/return-request/return-request";
import "components/jiffy/return-table/return-table";
import "components/jiffy/confirm-issue-or-claim/confirm-issue-or-claim";
import "components/jiffy/contactus-chat-button/contactus-chat-button.scss";
import "components/jiffy/tracking-info/tracking-info";
import "components/jiffy/tracking-numbers/tracking-numbers";
import initContactusConfirmationModal from "components/jiffy/contactus-confirmation-modal/contactus-confirmation-modal";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-address-confirmation")) initAddressConfirmation();
  if (document.querySelector(".js-late-order")) initLateOrder();
  if (document.querySelector(".js-claim-uploader-info")) initClaimImageUploader();
  initCustomReasonField();
  CustomerRequestFormTracker.init();
  initContactusConfirmationModal();
});
